<template>
  <div v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="activity-rules" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};`">
      <img @click="_close" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="modal-close" alt="">
      <header class="win-title" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">活动规则</header>
      <div class="rules-discript" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`" v-html="h5ConfigDetails[0]['activitySetting']['rules'][0]"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import ModalMask from '@/components/modal/ModalMask'

export default {
  name: 'ActivityRules',
  data () {
    return {
      baseUrl,
      showing: false
    }
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath'])
  },
  components: {
    ModalMask
  },
  methods: {
    show () {
      this.showing = true
    },
    _close () {
      this.showing = false
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';

  .activity-rules {
    width: 29.7rem;
    height: 39.1rem;
    text-align: center;
    .modal-common;
    /* .modal-anim; */
    background: rgb(255, 247, 238);
  }
  .win-title {
    font-size: 1.8rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #7E3E1B;
    line-height: 2.6rem;
    margin: 1.7rem 0 1.9rem 0;
    text-align: center;
  }
  .rules-discript {
    padding: 0 1.7rem 0 2.7rem;
    overflow-y: scroll;
    margin-right: 0.7rem;
    height: 30.6rem;
  }
  .rules-discript::-webkit-scrollbar{
    -webkit-appearance: none;
  }
  .rules-discript::-webkit-scrollbar:vertical{
    width:.2rem;
  }
  .rules-discript::-webkit-scrollbar-thumb{
    border: 1px solid #FADFAF;
    border-radius: .9rem;
    background-color: #FADFAF;

  }
  .rules-discript {
    text-align: left;
    margin-bottom: 1.5rem;
    font-size: 1.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A9420B;
    line-height: 1.9rem;
    -webkit-user-select: auto;
    user-select: all;
  }
</style>
